@if (dataModel()) {
    <p-tabs [value]="activeSubTab()" (valueChange)="activeSubTab.set($event)">
        <p-tablist>
            <p-tab value="0">{{ 'common.vendor-order-details' | translate }}</p-tab>
            <p-tab value="1">{{ 'product.unit-conversion' | translate }}</p-tab>
            <p-tab value="2" data-testid="vendor-product-edit-tab-transport-routes">{{ 'constants.transport-route' | translate }}</p-tab>
        </p-tablist>

        <p-tabpanels>
            <p-tabpanel value="0">
                <app-vendor-price-list-link-detail-widget
                    [(detailModelSig)]="dataModel"
                    [dataTestId]="
                        'formly-product-vendor-product-price-edit-vendor-relationships-list-vendor-price-list-link-detail-widget'
                    "
                    (onSaved)="onDetailsSaved($event)"
                />
            </p-tabpanel>
            <p-tabpanel value="1">
                @if (activeSubTab() === '1' || activeSubTab() === 1) {
                    <app-unit-conversion-config-link-list-widget
                        [autoloadItems]="false"
                        [vendorPriceListAddressLinkId]="dataModel()?.id"
                        [variantParentId]="product()?.variantParentId"
                        [variantParentIdentifier]="
                            product()?.variantParentIdentifier ?? product()?.variantParent?.identifier
                        "
                        [productId]="dataModel()?.productId"
                        [noEditOfNonVendorConversions]="true"
                        [baseUnit]="unit()"
                        [enableGlobalDeletion]="false"
                        [inlineEditMode]="true"
                        [addInDetail]="false"
                        [noBaseEdit]="true"
                    />
                }
            </p-tabpanel>
            <p-tabpanel value="2">
                @if ((activeSubTab() === '2' || activeSubTab() === 2) && dataModel()?.id) {
                    <!-- transport routes of this product from this vendor (DEV-3270): override the vendor's route values -->
                    <app-product-vendor-transport-routes-widget
                        [vendorPriceListAddressLinkId]="dataModel()!.id"
                        [addressId]="dataModel()!.addressId"
                        [currency]="dataModel()!.vendorPriceList?.currency"
                    />
                }
            </p-tabpanel>
        </p-tabpanels>
    </p-tabs>
}
